import React from 'react';

import { ISubSection, ISubSubSection } from '../../../typings/hlroom';
import SubSectionsFiltersChips from '../../molecules/sub-sections-filters-chips/sub-sections-filters-chips';
import SubSectionHeader from '../../molecules/sub-section-header/SubSectionHeader';
import SubSectionsMenu from '../../molecules/sub-sections-menu/SubSectionsMenu';
import styles, { IClassNames, makeClassNames } from '../../../utils/styles';

import './nav-lateral-bar.scss';

export interface INavLateralBar {
  isDesktop: boolean;
  subSectionSelected: ISubSection;
  subSubSectionSelected?: ISubSubSection;
  onSubSubSectionChange: (subSection: ISubSubSection | undefined) => void;
}

const NavLateralBar: React.FC<INavLateralBar> = ({
  isDesktop,
  subSectionSelected,
  subSubSectionSelected,
  onSubSubSectionChange,
}) => {
  const showFilterSubSections = () => isDesktop && Boolean(subSectionSelected.tag);

  const classNames = (): IClassNames =>
    makeClassNames({
      navLateralBar: ['nav-lateral-bar', !showFilterSubSections() && 'nav-lateral-bar--hide'],
    });
  const cn = classNames();

  const handleClickSubSection = () => {
    onSubSubSectionChange(undefined);
  };

  return (
    <div className={cn.navLateralBar}>
      <SubSectionHeader
        isDesktop={isDesktop}
        subSection={subSectionSelected}
        subSubSection={subSubSectionSelected}
        onClick={handleClickSubSection}
      />

      {subSectionSelected.subSubSections.length > 0 && <div className={styles('divider')} />}

      <SubSectionsFiltersChips
        isDesktop={isDesktop}
        subSectionSelected={subSectionSelected}
        subSubSectionSelected={subSubSectionSelected}
        onSubSubSectionChange={onSubSubSectionChange}
      />

      {subSectionSelected.subSubSections.length > 0 && <div className={styles('divider')} />}

      <SubSectionsMenu
        isDesktop={isDesktop}
        subSectionSelected={subSectionSelected}
        subSubSectionSelected={subSubSectionSelected}
        onSubSubSectionChange={onSubSubSectionChange}
      />
    </div>
  );
};
export default NavLateralBar;
